import { styled } from "styled-components";
import Colors from "../../styles/Colors";
import rem from "../../utils/rem";
const InputText = styled.span `
  display: inline-block;
  color: ${(props) => props.textColor ? Colors[props.textColor] : Colors.GRAY_DARKEST};
  font-size: ${rem(18)};
  line-height: ${rem(24)};
`;
export default InputText;
//# sourceMappingURL=InputText.js.map